/** ALFX support for survey analysis:
 *      - managing "days" read from sound location record
 *      - WPN2X-NightAnalysis-<id32>-<day>, the analysis JSON
 *      - night_variation: 16 values observed during the night
 *      - quiescent_wav: WAVE file data, the 'open' filtered quiescennt recording
 *      - quiescent_spectrum: Frequency spectrum of the quiescent recording
 *      - h_64_night: quiescent signal level measured for 64 nights
 */

export function dateOptionsForSensor(item) {
    const slDays = (Array.isArray(item.days) ? item.days : []);
    const dateOptions = slDays.map(x => {
        return {value: x, title: dateMMM_DDForDayCount(x)}
    });
    return dateOptions;
}

export function audioUrlFromAnalysis(analysis, wpn_id) {
    const base64AudioWavBytes = analysis.quiescent_wav;
    if (base64AudioWavBytes == undefined) {
        return (wpn_id != "WPNDemo002") ? undefined : 'https://sveltejs.github.io/assets/music/strauss.mp3';
    }
    const binaryString = atob(base64AudioWavBytes);
    const len = binaryString.length;
    const wavBytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        wavBytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([wavBytes], { type: 'audio/wav' });
    const audioUrl = URL.createObjectURL(blob);
    return audioUrl;
}

export function trendPointsFromAnalysis(analysis) {
    var soundTrend = analysis.night_variation ?? [];
    if (soundTrend.length < 2) {
        return [];
    }
    const yMax = Math.max.apply(null, soundTrend.map((trendPt) => trendPt.y));
    soundTrend.forEach(trendPt => trendPt.y /= yMax);
    const xMin = Math.min.apply(null, soundTrend.map((trendPt) => trendPt.x));
    const xSC = xMin % 3600;
    const xOffset = xMin - xSC;
    soundTrend.forEach(trendPt => trendPt.x -= xOffset);
    return soundTrend;
}

export function spectralPointsFromAnalysis(analysis) {
    const spectralData = analysis.quiescent_spectrum ?? [];
    const samp_rate = analysis.m_sampling_rate;
    if (samp_rate == undefined || spectralData.length < 3) {
        return [];
    }
    const yMax = Math.max.apply(null, spectralData);
    const decibelData = spectralData.map((x) => 20 * Math.log10(x / yMax));
    const nyquist_freq = samp_rate * 0.5;
    const xSF = nyquist_freq / (spectralData.length - 1);
    const points = decibelData.map((el, i) => { return {x: i * xSF, y: el} });
    return points;
} 

export function historyPointsFromAnalysis(analysis) {
    var histData = analysis.h_64_night ?? [];
    if (histData.length < 2) {
        return [];
    }
    const yMax = Math.max.apply(null, histData);
    const points = histData.map((el, i) => { return {x: i, y: el / yMax} });
    return points;
}

export function currentDay() {
    const creationTimestamp = Date.now();
    const originTime = new Date(2012, 4, 1, 0, 0, 0, 0).getTime();
    const msCount = creationTimestamp - originTime;
    const day = msCount / (1000 * 86400);
    return Math.trunc(day);
}

function dateMMM_DDForDayCount(dayCount) {
    let date = new Date(2012, 4, 1, 0, 0, 0, 0);
    date.setDate(date.getDate() + dayCount);
    let formattedDate = date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit'
    });
    return formattedDate;
}